export default __webpack_public_path__ + "static/media/DownloadIcon.bba47fd6.svg";